import React from 'react'
import PropTypes from 'prop-types'

export default class ErrorBoundary extends React.Component {


    componentDidCatch(error, info) {

        this.props.onError(error, info )

    }

    render() {

        return this.props.children
    }
}

ErrorBoundary.propTypes = {
    onError: PropTypes.func.isRequired ,
}


// WEBPACK FOOTER //
// ./src/components/_common/ErrorBoundary/index.js